import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Store } from '@ngrx/store'
import { AddressActions } from '../user-addresses.actions'
import { Router } from '@angular/router'
import { Address } from '../../user-profile/user-profile.state'

@Component({
  selector: 'cover-address-card[userAddress]',
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.scss'],
})
export class AddressCardComponent {
  //@Input() isSelected!: boolean
  @Input() userAddress!: Address

  @Output() delete: EventEmitter<void> = new EventEmitter<void>()
  @Output() setAsDefault: EventEmitter<void> = new EventEmitter<void>()

  constructor(private readonly store: Store, private readonly router: Router) {}

  edit(): void {
    this.store.dispatch(AddressActions.setAddressToEdit({ payload: this.userAddress }))
    this.router.navigateByUrl('/navigation/account/address/edit')
  }
}
